module.exports = __webpack_public_path__ + "img/3.f8675da9.png";